import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function DomainIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12C20 7.589 16.411 4 12 4C7.589 4 4 7.589 4 12C4 16.411 7.589 20 12 20C16.411 20 20 16.411 20 12ZM22 12C22 17.514 17.514 22 12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2C17.514 2 22 6.486 22 12ZM14.188 8.5L17 10.067V15H15.75V10.692L14.188 9.748L12.626 10.692V15H11.376V10.692L9.809 9.751L8.25 10.692V15H7V8.814H8.25V9.437L9.812 8.5L12.004 9.782L14.188 8.5Z",
    fill: "currentColor"
  }));
}